import Header from "../components/common/header&footer/Header";
import Footer from "../components/common/header&footer/Footer";

export default function MainLayout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
}
